import { Routes } from '@angular/router';
import { AddBrandComponent } from './add-brand/add-brand.component';
import { BrandsComponent } from './brands/brands.component';

export const BrandRoutingModule: Routes = [
	{ path: 'brands', component: BrandsComponent },
	{ path: 'add-brand', component: AddBrandComponent },
];
